import { Link } from 'react-router-dom';
import { HELP_ARTICLES } from '../content/site';

export function GuidesPage() {
  return (
    <section className="px-6 pt-28 pb-20 lg:px-10 lg:pt-36">
      <div className="mx-auto max-w-[860px]">
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-brand/15 bg-brand-light px-3 py-1.5 text-[0.72rem] font-bold tracking-widest text-brand uppercase">
          Guides
        </div>
        <h1 className="font-display mb-4 text-[2.75rem] leading-[1.06] font-extrabold text-ink lg:text-[3.25rem]">
          Written tutorials. No video library yet.
        </h1>
        <p className="mb-12 max-w-[54ch] text-[1.0625rem] leading-[1.7] text-ink-2">
          We do not host chat or video on this site. Use the articles below, or email support.
        </p>
        <div className="mk-stagger grid gap-3 sm:grid-cols-2">
          {HELP_ARTICLES.map((a) => (
            <Link
              key={a.slug}
              to={`/help/${a.slug}`}
              className="mk-lift rounded-2xl border border-line bg-panel p-5 shadow-sm hover:border-brand/30"
            >
              <h2 className="font-display mb-2 text-[1rem] font-bold text-ink">{a.title}</h2>
              <p className="text-[0.82rem] text-ink-3">{a.summary}</p>
            </Link>
          ))}
        </div>
        <p className="mt-10 text-[0.88rem] text-ink-3">
          Email{' '}
          <a href="mailto:support@cevop.com" className="font-semibold text-brand">
            support@cevop.com
          </a>
        </p>
      </div>
    </section>
  );
}
